import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import { Card, Placeholder } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Container = styled.div`
  max-width:700px;
  margin-left:auto;
  margin-right:auto;
  margin-bottom: 10%;

  img {
    max-width:100%;
  }
    >div {
      margin: 1em 0.5em;
    }
    `;

const Title = styled.div`
  display:flex;
  margin:10px;
  svg {
    margin:0px 10px;
  }
`

interface MarkdownPageParams {
  filePath:string
  title:string
  githubPath:string
}

function MarkdownPage(params:MarkdownPageParams) {
  const [markdownContent, setMarkdownContent] = useState('');

  useEffect(() => {
    // Markdown 파일을 가져오기 위한 비동기 함수를 정의합니다.
    const fetchMarkdown = async () => {
      try {
        const response = await fetch(params.filePath);
        const markdownText = await response.text();
        setMarkdownContent(markdownText);
      } catch (error) {
        console.error('Error fetching markdown:', error);
      }
    };

    // 비동기 함수 호출
    fetchMarkdown();
  }, [params.filePath]); // useEffect의 두 번째 매개변수로 빈 배열을 전달하여 한 번만 실행되도록 설정

  return (
    <Container>
      <Title>
        <h3>{params.title}</h3>
        <Link to={params.githubPath} >
        <svg height="32" aria-hidden="true" viewBox="0 0 16 16" version="1.1" width="32" data-view-component="true" className="octicon octicon-mark-github v-align-middle color-fg-default">
          <path d="M8 0c4.42 0 8 3.58 8 8a8.013 8.013 0 0 1-5.45 7.59c-.4.08-.55-.17-.55-.38 0-.27.01-1.13.01-2.2 0-.75-.25-1.23-.54-1.48 1.78-.2 3.65-.88 3.65-3.95 0-.88-.31-1.59-.82-2.15.08-.2.36-1.02-.08-2.12 0 0-.67-.22-2.2.82-.64-.18-1.32-.27-2-.27-.68 0-1.36.09-2 .27-1.53-1.03-2.2-.82-2.2-.82-.44 1.1-.16 1.92-.08 2.12-.51.56-.82 1.28-.82 2.15 0 3.06 1.86 3.75 3.64 3.95-.23.2-.44.55-.51 1.07-.46.21-1.61.55-2.33-.66-.15-.24-.6-.83-1.23-.82-.67.01-.27.38.01.53.34.19.73.9.82 1.13.16.45.68 1.31 2.69.94 0 .67.01 1.3.01 1.49 0 .21-.15.45-.55.38A7.995 7.995 0 0 1 0 8c0-4.42 3.58-8 8-8Z"></path>
        </svg>
       </Link>
      </Title>
      <Card style={{padding:"20px"}}>
        {(markdownContent === '')?
          <>
          <Placeholder animation="glow">
            <Placeholder xs={7} /> <Placeholder xs={4} /> <Placeholder xs={4} />{' '}
            <Placeholder xs={6} /> <Placeholder xs={8} />
          </Placeholder>
          </>
            :
          <ReactMarkdown>{markdownContent}</ReactMarkdown>
        }
      </Card>
    </Container>
  );
}

export default MarkdownPage;
